<div class="app-report-control d-flex flex-row-reverse align-items-start" [class.section-title]="control().isSectionTitle">
  <button mat-icon-button (click)="delete()"><mat-icon class="md-20">delete</mat-icon></button>
  <div class="content">
    <div class="report-control" [class.inline]="control().inline">
      @if (control().isProcedureField) {
        <xmed-procedure-field-renderer [control]="control()"></xmed-procedure-field-renderer>
      }
      @if (control().isSingleLineTextField) {
        <xmed-single-line-text-field-renderer [control]="control()"></xmed-single-line-text-field-renderer>
      }
      @if (control().isDatePicker) {
        <xmed-date-picker-renderer [control]="control()"></xmed-date-picker-renderer>
      }
      @if (control().isMultiLineTextField) {
        <xmed-multi-line-text-field-renderer [control]="control()"></xmed-multi-line-text-field-renderer>
      }
      @if (control().isJumpTextField) {
        <xmed-multi-line-text-field-renderer [control]="control()"></xmed-multi-line-text-field-renderer>
      }
      @if (control().isLatestComment) {
        <xmed-comment-field-renderer [control]="control()"></xmed-comment-field-renderer>
      }
      @if (control().isProblemList) {
        <xmed-problem-list-renderer [patientId]="patientId()" [control]="control()" [refreshTrigger]="problemRefreshTrigger()"></xmed-problem-list-renderer>
      }
      @if (control().isMedicationList) {
        <xmed-medication-list-renderer [patientId]="patientId()" [control]="control()" [refreshTrigger]="medicationRefreshTrigger()"></xmed-medication-list-renderer>
      }
      @if (control().isTreatmentPlanList) {
        <xmed-treatment-plan-list-renderer [patientId]="patientId()" [control]="control()" [refreshTrigger]="treatmentPlanRefreshTrigger()"></xmed-treatment-plan-list-renderer>
      }
      @if (control().isBillingIcd10List) {
        <xmed-billing-icd10-list-renderer [control]="control()"></xmed-billing-icd10-list-renderer>
      }
      @if (control().isBillingLineItems) {
        <xmed-billing-line-items-renderer [control]="control()"></xmed-billing-line-items-renderer>
      }
      @if (control().isPatientSummary) {
        <xmed-patient-summary-renderer [control]="control()"></xmed-patient-summary-renderer>
      }
    </div>
    @if (control().isSectionTitle) {
      <xmed-section-title-renderer [control]="control()"></xmed-section-title-renderer>
    }
  </div>
</div>
